import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M18.724 20.304a.907.907 0 0 1-.649.267.901.901 0 0 1-.907-.892.88.88 0 0 1 .26-.626.906.906 0 0 1 .647-.267.9.9 0 0 1 .908.892c0 .235-.093.46-.259.626Zm-10.28 0a.905.905 0 0 1-.648.267c-.5 0-.908-.4-.908-.892a.902.902 0 0 1 .908-.893c.5 0 .907.4.908.892a.883.883 0 0 1-.26.626Zm11.75-14.732-1.941 7.856H7.559L5.576 5.572h14.618Zm-2.119 11.785c-.035 0-.067.009-.101.01-.019-.001-.034-.011-.053-.011h-9.37l-.631-2.498h11.434L22 4.143H5.215l-.133-.53A2.122 2.122 0 0 0 3.03 2h-.324A.71.71 0 0 0 2 2.715a.71.71 0 0 0 .706.715h.324c.323 0 .605.221.684.537L7.122 17.47A2.31 2.31 0 0 0 5.7 20.675a2.32 2.32 0 0 0 4.237-1.888h5.999a2.32 2.32 0 1 0 4.46.892 2.322 2.322 0 0 0-2.321-2.322Z"
    />
  </svg>
);

const Icon = createSvgIcon(svg, 'Basket');

export default Icon;
